module.exports = __webpack_public_path__ + "img/6.c7f35ab1.jpg";